import { hsla, mix } from 'polished';

export const black = hsla(0, 0, 0, 1);
export const white = hsla(0, 0, 1, 1);

export const red = hsla(10, 1, 0.7, 1);
export const yellow = hsla(10 + 60, 1, 0.7, 1);
export const green = hsla(10 + 120, 1, 0.7, 1);
export const cyan = hsla(10 + 180, 1, 0.7, 1);
export const blue = hsla(10 + 240, 1, 0.7, 1);
export const magenta = hsla(10 + 300, 1, 0.7, 1);

export const royalblue1 = 'royalblue';
export const royalblue2 = hsla(225, 0.73, 0.57, 1);
export const royalblue3 = hsla(233, 0.95, 0.57, 1);
export const royalblue4 = hsla(236, 1, 0.55, 1);
export const royalblue5 = hsla(246, 0.98, 0.5, 1);
export const royalblue6 = hsla(247, 0.99, 0.45, 1);
export const royalblue7 = hsla(241, 0.88, 0.39, 1);
export const royalblue8 = hsla(222, 0.75, 0.49, 1);
export const royalblue9 = hsla(222, 1, 0.36, 1); // #0039B9 of v1.0.0

export const yellow1 = 'yellow';
export const yellow2 = hsla(60, 1, 0.5, 1);
export const yellow3 = hsla(60, 0.84, 0.57, 1);
export const yellow4 = hsla(40, 0.94, 0.59, 1);
export const yellow5 = hsla(60, 0.9, 0.5, 1);

export const baseColor = white;
export const darkBaseColor = hsla(0, 0, 0.87, 1);

export const lineColor = mix(0.8, black, white);

export const primaryColor = royalblue9;
export const lightPrimaryColor = hsla(221, 0.58, 0.94, 1);

export const accentColor = yellow5;

